import React, { useState, useEffect } from "react";
import { Box } from "@otrium/core";
import { RadioButton } from "src/atoms/Radio/Radio.styled";
import { PspPaymentMethod } from "src/types/graphql.d";
import { MollieCardComponents } from "src/molecules/MollieCardComponents";
import AmexIconBackground from "src/icons/AmexIconBackground";
import MaestroIconBackground from "src/icons/MaestroIconBackground";
import VisaIconBackground from "src/icons/VisaIconBackground";
import BancontactIconBackground from "src/icons/BancontactIconBackground";
import MasterCardIconBackground from "src/icons/MasterCardIconBackground";
import { Wrapper } from "./PaymentMethodSelector.styled";
import { canHandleApplePay } from "src/utils/applepay/applePayHelper";
import { theme } from "src/theme";

const PaymentMethodSelector: React.FC<{
  paymentMethods: PspPaymentMethod[];
  onPaymentMethodSelected: (methodId: string) => void;
}> = ({ paymentMethods, onPaymentMethodSelected }) => {
  const [selectedMethod, setSelectedMethod] = useState<string | null>(null);

  useEffect(() => {
    // Selects the first available payment method by default
    if (paymentMethods.length > 0) {
      setSelectedMethod(paymentMethods[0].id);
      onPaymentMethodSelected(paymentMethods[0].id);
    }
  }, [paymentMethods]);

  const handlePaymentMethodSelected = (methodId: string) => {
    setSelectedMethod(methodId);
    onPaymentMethodSelected(methodId);
  };

  // Ensure we filter out Apple Pay if the browser does not support it
  paymentMethods = paymentMethods.filter((method) => {
    if (method.id === "applepay" && !canHandleApplePay()) {
      return false;
    }
    return true;
  });

  return (
    <Box mt={4}>
      {paymentMethods.map((method) => (
        <div key={method.id}>
          <div
            onClick={() => handlePaymentMethodSelected(method.id)}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              marginBottom: "20px",
              marginTop: "10px",
            }}
          >
            <RadioButton
              checked={selectedMethod === method.id}
              type="radio"
              readOnly={true}
            />

            <img
              src={method.image}
              alt={method.description}
              style={{
                marginLeft: "10px",
                marginRight: "10px",
                width: "40px",
                height: "30px",
              }}
            />
            <span>{method.description}</span>

            <div style={{ marginLeft: theme.space.space32 }}>
              {method.id === "creditcard" && (
                <Wrapper>
                  <BancontactIconBackground />
                  <MasterCardIconBackground />
                  <VisaIconBackground />
                  <AmexIconBackground />
                  <MaestroIconBackground />
                </Wrapper>
              )}

              {method.id === "bancontact" && (
                <Wrapper>
                  <BancontactIconBackground />
                  <MaestroIconBackground />
                  <VisaIconBackground />
                </Wrapper>
              )}
            </div>
          </div>
          {method.id === "creditcard" && (
            <MollieCardComponents selectedMethod={selectedMethod} />
          )}
        </div>
      ))}
    </Box>
  );
};

export default PaymentMethodSelector;
